module.exports = __webpack_public_path__ + "static/media/msgadd.c38ccb8f.svg";